import { RecordHistoryPage } from '@/components/audit-log/RecordHistoryPage'
import { usePathHelper } from '@/hooks/usePathHelper'
import { adminTitleHead } from '@/lib/admin-route-title'
import { auditLogQueries } from '@/lib/services/audit-log/audit-log.query'
import { cashDrawerQueries } from '@/lib/services/cash-drawers/cash-drawers.query'
import { organizationQueries } from '@/lib/services/organizations/organizations.query'
import { isGlobalOrganization } from '@/lib/user-access'
import { createFileRoute, notFound } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/settings/cash-drawer/history')({
  component: CashDrawerSettingsHistoryPage,
  head: () => adminTitleHead('History', 'Cash Drawer', 'Settings'),
  loader: async ({ context, params }) => {
    if (
      !context.ability.can('view', 'cash-drawer-settings') ||
      !context.ability.can('view', 'audit-logs')
    ) {
      throw notFound()
    }

    const organization = await context.queryClient.ensureQueryData(
      organizationQueries.show(params.orgId)
    )

    if (isGlobalOrganization(organization)) throw notFound()

    await Promise.all([
      context.queryClient.ensureQueryData(
        cashDrawerQueries.settings({ organizationId: params.orgId })
      ),
      context.queryClient.ensureInfiniteQueryData(
        auditLogQueries.record({
          organizationId: params.orgId,
          subject: 'cash-drawer-settings',
          recordId: params.orgId,
        })
      ),
    ])
  },
})

function CashDrawerSettingsHistoryPage() {
  const { orgId } = Route.useParams()
  const path = usePathHelper()

  return (
    <RecordHistoryPage
      backLabel="cash drawer settings"
      backLink={path.cashDrawerSettings.index().link}
      description="Review changes to cash drawer tracking for this shop."
      organizationId={orgId}
      recordId={orgId}
      recordLabel="Cash drawer settings"
      subject="cash-drawer-settings"
    />
  )
}
